const SUCURSALES = {
    51:"San Juan",
    52:"Avenida Petapa",
    54:"Aguilar Batres",
    55:"Zona 6",
    56:"San Cristóbal",
    57:"Villa Nueva",
    58:"El Naranjo",
}

const INICIALES = {
    51:"SJ",
    52:"PT",
    54:"AB",
    55:"Z6",
    56:"SC",
    57:"VN",
    58:"NJ",
}

const COLORES = {
    51:"red-500",
    52:"yellow-500",
    54:"secundario",
    55:"blue-500",
    56:"green-500",
    57:"secundario",
    58:"yellow-400",
}

const CURSOS_INGLES = {
    10: {inicial:'B0',       color: 'green-100',  text:"green-900"},
    11: {inicial:'B1',       color: 'green-100',  text:"green-900"},
    12: {inicial:'B2',       color: 'green-100',  text:"yellow-900"},
    13: {inicial:'B3',       color: 'green-100',  text:"green-900"},
    14: {inicial:'B4',       color: 'green-100',  text:"indigo-900"},
    15: {inicial:'E5',       color: 'red-100',    text:"red-900"},
    16: {inicial:'E6',       color: 'red-100',    text:"indigo-900"},
    17: {inicial:'E7',       color: 'red-100',    text:"purple-900"},
    18: {inicial:'E8',       color: 'red-100',    text:"blue-900"},
    19: {inicial:'Pre-I 9',  color: 'yellow-100', text:"yellow-900"},
    20: {inicial:'Pre-I 10', color: 'yellow-100', text:"red-900"},
    21: {inicial:'Pre-I 11', color: 'yellow-100', text:"yellow-900"},
    22: {inicial:'Pre-I 12', color: 'yellow-100', text:"red-900"},

    23: {inicial:'Pre-I 11', color: 'yellow-100', text:"yellow-900"},
    24: {inicial:'B1',       color: 'green-100',  text:"green-900"},
    25: {inicial:'B2',       color: 'green-100',  text:"yellow-900"},
    26: {inicial:'B3',       color: 'green-100',  text:"green-900"},
    27: {inicial:'B4',       color: 'green-100',  text:"indigo-900"},
    28: {inicial:'E5',       color: 'red-100',    text:"red-900"},
    29: {inicial:'E6',       color: 'red-100',    text:"indigo-900"},
    30: {inicial:'E7',       color: 'red-100',    text:"purple-900"},
    31: {inicial:'Pre-I 11', color: 'yellow-100', text:"yellow-900"},
    32: {inicial:'B1',       color: 'green-100',  text:"green-900"},
    33: {inicial:'B2',       color: 'green-100',  text:"yellow-900"},
    34: {inicial:'B3',       color: 'green-100',  text:"green-900"},
    35: {inicial:'B4',       color: 'green-100',  text:"indigo-900"},
    36: {inicial:'E5',       color: 'red-100',    text:"red-900"},
    37: {inicial:'E6',       color: 'red-100',    text:"indigo-900"},
    38: {inicial:'E7',       color: 'red-100',    text:"purple-900"},
}
    
    
/*
      primarioMira: '#233044',
      secundarioMira: '#1b2635',
      grisMira: '#9197a1',
      azulBrillanteMira: '#4782da',
      azulOscuroMira: '#2e4b76',
      rojoMira: '#FF1D0D',
      mostazaMira: '#E68A00',
      azulLogos: '#146F8E',
      blueNoti: '#1876f2'
*/
/*
illustrator.png
photoshop.png

csharp.png
java.png
websitex5.png

iexplorer.png
windows.png
excel.png
powerpoint.png
publisher.png
word.png
*/
const ICONO_CATALOGOS = {
    '1': ['windows.png', 
        'excel.png', 
        'powerpoint.png', 
        'publisher.png', 
        'word.png'
       ], 
    '2': [
        'csharp.png',
        'java.png',
        'websitex5.png',
       ],
    '3': [
        'illustrator.png',
        'photoshop.png',
       ],
    '4': ['ingles.png']
}

export {
    SUCURSALES,
    INICIALES,
    COLORES,
    CURSOS_INGLES,
    ICONO_CATALOGOS,
}
/*
[
    {
        "IdCatalogo": "3",
        "Descripcion": "Diseño"
    },
    {
        "IdCatalogo": "4",
        "Descripcion": "Inglés"
    },
    {
        "IdCatalogo": "1",
        "Descripcion": "Oficina"
    },
    {
        "IdCatalogo": "2",
        "Descripcion": "Programación"
    }
]
*/
/*
10	'Let´s Begin'
11	'Beginner Level 1'
12	'Beginner Level 2'
13	'Beginner Level 3'
14	'Beginner Level 4'
15	'Elementary Level 5'
16	'Elementary Level 6'
17	'Elementary Level 7'
18	'Elementary Level 8'
19	'Pre-Intermediate Level 9'
20	'Pre-Intermediate Level 10'
21	'Pre-Intermediate Level 11'
22	'Pre-Intermediate Level 12'
*/